<button class="flex items-center gap-x-2" (click)="toggle()">
  <div
    data-testid="checkbox-box"
    class="relative aspect-square"
    [style.width]="size()"
    [style.height]="size()">
    <div
      class="absolute top-0 right-0 bottom-0 left-0 rounded-sm border"
      [ngClass]="[
        borderColorTailwindClass(),
        checkbox().checked() ? backgroundColorTailwindClass() : 'bg-white',
      ]"></div>
    <div
      class="absolute top-0 right-0 bottom-0 left-0 z-10 flex scale-60 items-center justify-center"
      [ngClass]="[checkColorTailwindClass(), !checkbox().checked() ? 'hidden' : '']">
      <shared-core-material-icon class="h-full w-full" [name]="'check'" />
    </div>
  </div>
  <div
    class="text-left text-sm"
    [ngClass]="textWidthClass()"
    sharedCoreTooltipOnContentOverflow
    [reevaluationSubject]="reevaluationSubject"
    [displayedValue]="checkbox().text"></div>
</button>
